import React from 'react';
import { Typography } from 'glints-aries/lib/@next';
import { useIntl } from 'react-intl';
import QRCode from 'react-qr-code';

import * as S from './MobileAppDownloadQRBanner.sc';

type Props = { link: string; id: string };

export const MobileAppDownloadQRBanner: React.FC<Props> = ({
  link,
  id,
}: Props) => {
  const intl = useIntl();

  const messageGetRealTimeUpdates = intl.formatMessage({
    id: 'text-get-real-time-updates',
    defaultMessage: 'Get real-time updates only on the Glints App',
  });
  const qrCodeDownloadText = intl.formatMessage({
    id: 'text-scan-the-qr-code-to-download',
    defaultMessage: 'Scan the QR code to download',
  });

  return (
    <S.QRSectionContainer id={id}>
      <S.QRCodeContainer>
        <QRCode value={link} size={64} />
      </S.QRCodeContainer>
      <S.QRSectionTextContainer>
        <span>{messageGetRealTimeUpdates}</span>
        <Typography variant="overline">
          <span>{qrCodeDownloadText}</span>
        </Typography>
      </S.QRSectionTextContainer>
    </S.QRSectionContainer>
  );
};
